// Lib
import React from 'react';

// Components
import FullScreenErrorModal from '../../../modal/FullScreenErrorModal';
import ModalActionsList from '../../../modal/ModalActionsList';

const BrowserCookieFullScreenWarning = (props) => (
    <FullScreenErrorModal>
        <h2>Sorry, you need to enable storage to use Milanote</h2>
        <p className="explanation">
            Milanote uses your browser&apos;s storage to save data while you&apos;re working, please enable it and try
            again.
        </p>
        <ModalActionsList actions={[{ text: 'Find out more', href: 'http://www.whatarecookies.com/' }]} />
    </FullScreenErrorModal>
);

BrowserCookieFullScreenWarning.propTypes = {};

export default BrowserCookieFullScreenWarning;
